<div class="w-full p-gutter text-center">
    <img class="w-full max-w-lg mx-auto mb-6" src="assets/img/illustrations/data_center.svg">

    <h2 class="headline m-0">{{ state.error.toUpperCase() }}</h2>
    <h3 class="text-secondary m-0">{{ state.error_description }}</h3>
    <p class="py-8">
        <button mat-raised-button color="primary" onclick="history.go(-1)"> GO BACK </button>
    </p>
</div>